import { Carousel } from "antd";
import classnames from "classnames";
import { FunctionComponent } from "react";
import { FilledChevron } from "rivals/public/static/icons";
import styles from "./index.module.scss";
import { CarouselButtonProps, OwnProps } from "./types";

const smDesktopWidthCarouselContents = 3;
const desktopWidthCarouselContents = 4;

const CarouselButton: FunctionComponent<CarouselButtonProps> = ({
  className,
  isPrev,
  onClick,
  shadowIndicator,
  style
}) => {
  const button = (
    <div
      className={classnames(className, styles.carouselButton, {
        [styles.prevButton]: isPrev,
        [styles.disabled]: !onClick
      })}
      onClick={onClick}
      style={style}
    >
      <FilledChevron />
    </div>
  );

  return shadowIndicator ? (
    <div
      className={classnames({
        [styles.prevShadow]: isPrev,
        [styles.nextShadow]: !isPrev
      })}
    >
      {button}
    </div>
  ) : (
    button
  );
};

const Slider = ({
  children,
  className = "",
  shadowIndicator = false,
  ...props
}: OwnProps): JSX.Element => (
  <Carousel
    arrows
    className={classnames(styles.slider, className)}
    dots={false}
    draggable
    infinite={false}
    nextArrow={<CarouselButton shadowIndicator={shadowIndicator} />}
    prevArrow={
      <CarouselButton isPrev={true} shadowIndicator={shadowIndicator} />
    }
    responsive={[
      {
        breakpoint: parseInt(styles["screen-lg-desktop-max"]),
        settings: {
          slidesToShow: props.sidebar ? 1 : desktopWidthCarouselContents
        }
      },
      {
        breakpoint: parseInt(styles["screen-sm-desktop-max"]),
        settings: {
          slidesToShow: props.sidebar ? 1 : smDesktopWidthCarouselContents
        }
      },
      {
        breakpoint: parseInt(styles["screen-tablet-max"]),
        settings: {
          slidesToShow: 2.4
        }
      },
      {
        breakpoint: parseInt(styles["screen-lg-mobile-max"]),
        settings: {
          slidesToShow: 1.5
        }
      },
      {
        breakpoint: parseInt(styles["screen-mobile-max"]),
        settings: {
          slidesToShow: 1.1
        }
      }
    ]}
    swipeToSlide
    {...props}
  >
    {children}
  </Carousel>
);

export default Slider;
